import { Center, Column, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import ConfirmPopup from '../../shared/ConfirmPopup';
import { PaymentFailedPopup } from './PaymentFailedPopup';
import { PaymentSuccessPopup } from './PaymentSuccessPopup';
import { PopupWarningIcon } from './PopupWarningIcon';
import { SuspendedPostingsList } from './SuspendedPostingsList';
import { useSuspendedPostingsPopup } from './useSuspendedPostingsPopup';

const DESCRIPTION_WRAPPER_STYLE: React.CSSProperties = {
  width: '80%',
};

// center the description box (it sits in a plain block wrapper); 38px overrides ConfirmPopup's built-in description-to-button gap
const DESCRIPTION_PROP_STYLE: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 38,
};

export const SuspendedPostingsPopup = () => {
  const {
    isOpen,
    suspendedPostings,
    failedPostings,
    totalCount,
    isProcessing,
    paymentResultState,
    handlePayNow,
    handlePayLater,
    handleCloseSuccessPopup,
    handleRetryFromFailedPopup,
    handlePayLaterFromFailedPopup,
  } = useSuspendedPostingsPopup();

  const renderDescription = () => {
    return (
      <Center style={DESCRIPTION_WRAPPER_STYLE}>
        <Column gap={4}>
          <Typography size="body_large" color={colors.neutral[500]}>
            These [{totalCount}] job postings are currently suspended:
          </Typography>

          <SuspendedPostingsList postings={suspendedPostings} />

          <Typography size="body_large" color={colors.neutral[500]}>
            To reactivate them, click &quot;Pay Now&quot;. Once payment is confirmed, your jobs will
            reappear for professionals to view and apply.
          </Typography>
        </Column>
      </Center>
    );
  };

  return (
    <>
      {isOpen && suspendedPostings.length > 0 && (
        //@ts-expect-error missing some props from ConfirmPopup
        <ConfirmPopup
          title="Action Needed: Unpaid Job Postings"
          description={renderDescription}
          Icon={PopupWarningIcon}
          leftButtonText="Pay Later"
          rightButtonText="Pay Now"
          leftButtonAction={handlePayLater}
          rightButtonAction={handlePayNow}
          rightButtonLoading={isProcessing}
          rightButtonDisabled={isProcessing}
          closePopup={handlePayLater}
          dismissiblePopup={false}
          showClosePopupIcon={false}
          descriptionStyle={DESCRIPTION_PROP_STYLE}
        />
      )}

      <PaymentSuccessPopup
        isOpen={paymentResultState === 'success'}
        onClose={handleCloseSuccessPopup}
      />

      <PaymentFailedPopup
        isOpen={paymentResultState === 'failed'}
        failedPostings={failedPostings}
        totalCount={failedPostings.length}
        onRetry={handleRetryFromFailedPopup}
        onPayLater={handlePayLaterFromFailedPopup}
      />
    </>
  );
};
